import { render, staticRenderFns } from "./SlidesLogo.vue?vue&type=template&id=7a2efd23&functional=true"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports